import {MetricsSection} from '/constant/TestIDs';
import {BUSINESS_COACH, BUSINESS_LEADER, COACH} from '/enum/competency.enum';
import {useTranslation} from '/provider/TranslationProvider';
interface UseListItemsParams {
  component: React.ElementType;
  currentUserCompetency: string;
  frontlineQualifyingVolume: number | string;
  generation0Volume: number | string;
  totalGenerationVolume: number | string;
  orderingEntities: number;
  qualifyingPoints: number;
}

export function useListItems({
  component,
  currentUserCompetency,
  frontlineQualifyingVolume,
  generation0Volume,
  totalGenerationVolume,
  orderingEntities,
  qualifyingPoints,
}: UseListItemsParams) {
  const {tt} = useTranslation('screen.performance.section.personalPerformance');

  const parseToNumber = (value: number | string): number =>
    typeof value === 'string' ? parseFloat(value) : value;

  const frontlineQualifyingVolumeItem = {
    label: tt('frontlineQualifyingVolume', 'Frontline Qualifying Volume'),
    value: parseToNumber(frontlineQualifyingVolume),
    component,
    testID: MetricsSection.metricFrontlineQualifyingVolume,
  };

  const generation0VolumeItem = {
    label: tt('generation0Volume', 'Generation 0 Volume'),
    value: parseToNumber(generation0Volume),
    component,
    testID: MetricsSection.metricGeneration0Volume,
  };

  const totalGenerationVolumeItem = {
    label: tt('totalGenerationVolume', 'Total Generation Volume'),
    value: parseToNumber(totalGenerationVolume),
    component,
    testID: MetricsSection.metricTotalGenerationVolume,
  };

  const orderingEntitiesItem = {
    label: tt('orderingEntities', 'Ordering Entities'),
    value: orderingEntities,
    component,
    testID: MetricsSection.metricOrderingEntities,
  };

  const qualifyingPointsItem = {
    label: tt('qualifyingPoints', 'Qualifying Points'),
    value: qualifyingPoints,
    component,
    testID: MetricsSection.metricQualifyingPoints,
  };

  const listItems = [frontlineQualifyingVolumeItem];
  if (currentUserCompetency === COACH) {
    return [...listItems, orderingEntitiesItem, qualifyingPointsItem];
  } else if (currentUserCompetency === BUSINESS_COACH) {
    return [
      ...listItems,
      generation0VolumeItem,
      orderingEntitiesItem,
      qualifyingPointsItem,
    ];
  } else if (currentUserCompetency === BUSINESS_LEADER) {
    return [
      ...listItems,
      generation0VolumeItem,
      totalGenerationVolumeItem,
      orderingEntitiesItem,
      qualifyingPointsItem,
    ];
  }

  return [];
}
